import { render } from "./d-list-item-multi-view.vue?vue&type=template&id=22639031&scoped=true&ts=true"
import script from "./d-list-item-multi-view.vue?vue&type=script&lang=ts"
export * from "./d-list-item-multi-view.vue?vue&type=script&lang=ts"

import "./d-list-item-multi-view.vue?vue&type=style&index=0&id=22639031&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22639031"]])

export default __exports__